export const currencyOptions = [
  {
    code: "AUD",
    label: "🇦🇺 AUD (A$)",
    symbol: "A$",
    kayakDomain: "kayak.com.au",
    countryCode: "AU", // 🇦🇺 Australia
  },
  {
    code: "BRL",
    label: "🇧🇷 BRL (R$)",
    symbol: "R$",
    kayakDomain: "kayak.com.br",
    countryCode: "BR", // 🇧🇷 Brazil
  },
  {
    code: "CAD",
    label: "🇨🇦 CAD (C$)",
    symbol: "C$",
    kayakDomain: "ca.kayak.com",
    countryCode: "CA", // 🇨🇦 Canada
  },
  {
    code: "CHF",
    label: "🇨🇭 CHF (Fr)",
    symbol: "Fr",
    kayakDomain: "kayak.ch",
    countryCode: "CH", // 🇨🇭 Switzerland
  },
  {
    code: "CNY",
    label: "🇨🇳 CNY (¥)",
    symbol: "¥",
    kayakDomain: "kayak.com",
    countryCode: "CN", // 🇨🇳 China
  },
  {
    code: "EUR",
    label: "🇪🇺 EUR (€)",
    symbol: "€",
    kayakDomain: "kayak.ie",
    countryCode: "IE", // 🇮🇪 Ireland (Best for English + Euro)
  },
  {
    code: "GBP",
    label: "🇬🇧 GBP (£)",
    symbol: "£",
    kayakDomain: "kayak.co.uk",
    countryCode: "GB", // 🇬🇧 United Kingdom
  },
  {
    code: "HKD",
    label: "🇭🇰 HKD (HK$)",
    symbol: "HK$",
    kayakDomain: "kayak.com.hk",
    countryCode: "HK", // 🇭🇰 Hong Kong
  },
  {
    code: "INR",
    label: "🇮🇳 INR (₹)",
    symbol: "₹",
    kayakDomain: "kayak.co.in",
    countryCode: "IN", // 🇮🇳 India
  },
  {
    code: "JPY",
    label: "🇯🇵 JPY (¥)",
    symbol: "¥",
    kayakDomain: "kayak.co.jp",
    countryCode: "JP", // 🇯🇵 Japan
  },
  {
    code: "KRW",
    label: "🇰🇷 KRW (₩)",
    symbol: "₩",
    kayakDomain: "kayak.co.kr",
    countryCode: "KR", // 🇰🇷 South Korea
  },
  {
    code: "MXN",
    label: "🇲🇽 MXN (Mex$)",
    symbol: "Mex$",
    kayakDomain: "kayak.com.mx",
    countryCode: "MX", // 🇲🇽 Mexico
  },
  {
    code: "NOK",
    label: "🇳🇴 NOK (kr)",
    symbol: "kr",
    kayakDomain: "kayak.no",
    countryCode: "NO", // 🇳🇴 Norway
  },
  {
    code: "NZD",
    label: "🇳🇿 NZD (NZ$)",
    symbol: "NZ$",
    kayakDomain: "kayak.co.nz",
    countryCode: "NZ", // 🇳🇿 New Zealand
  },
  {
    code: "SEK",
    label: "🇸🇪 SEK (kr)",
    symbol: "kr",
    kayakDomain: "kayak.se",
    countryCode: "SE", // 🇸🇪 Sweden
  },
  {
    code: "SGD",
    label: "🇸🇬 SGD (S$)",
    symbol: "S$",
    kayakDomain: "kayak.sg",
    countryCode: "SG", // 🇸🇬 Singapore
  },
  {
    code: "USD",
    label: "🇺🇸 USD ($)",
    symbol: "$",
    kayakDomain: "kayak.com",
    countryCode: "US", // 🇺🇸 United States
  },
  {
    code: "ZAR",
    label: "🇿🇦 ZAR (R)",
    symbol: "R",
    kayakDomain: "kayak.com",
    countryCode: "ZA", // 🇿🇦 South Africa
  },
];

export const formatPrice = (amount, currencyCode, showCode = true) => {
  const currency = currencyOptions.find((c) => c.code === currencyCode);
  const symbol = currency?.symbol || currencyCode;
  const formatted = `${symbol}${amount.toLocaleString()}`;
  return showCode ? `${formatted} ${currencyCode}` : formatted;
};

// Bonus: Helper to get the Kayak URL
export const getKayakUrl = (currencyCode) => {
  const currency = currencyOptions.find((c) => c.code === currencyCode);
  return currency
    ? `https://www.${currency.kayakDomain}`
    : "https://www.kayak.com";
};
